import type { LearnerExam } from "../content-schema";

type Module = Pick<LearnerExam["modules"][number], "id" | "section" | "stage" | "routeBand" | "variantOf">;
export const previewSections = ["reading_writing", "math"] as const;
export const sectionLabel = (section: string) => section === "math" ? "Math" : "Reading and Writing";
export const routeLabel = (band: string) => band === "higher" ? "Harder" : band === "lower" ? "Easier" : "Fixed";

export function previewRouteOptions<T extends Module>(modules: T[], section: Module["section"]) {
  const options = modules.filter(m => !m.variantOf && m.section === section && m.stage === 2);
  return options.some(m => m.routeBand === "lower") && options.some(m => m.routeBand === "higher") ? options : [];
}

/** Preview selections never change an attempt's automatic routing. */
export function previewModules<T extends Module>(modules: T[], routes: Record<string, string> = {}): T[] {
  return previewSections.flatMap(section => [1, 2].flatMap(stage => {
    const options = modules.filter(m => !m.variantOf && m.section === section && m.stage === stage);
    return options.find(m => stage === 2 && m.id === routes[section])
      ?? options.find(m => m.routeBand === "common" || m.routeBand === "unknown")
      ?? options.find(m => m.routeBand === "lower") ?? options[0] ?? [];
  }));
}
